import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClientService } from 'app/core/services/http-client.service';

import { Seller, ResponseMetadata } from 'app/model';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

@Injectable()
export class SellerService {

  constructor(private httpService: HttpClientService) {
  }

  getAllSellers(params?): Observable<{ sellers: Seller[], metadata: ResponseMetadata }> {
    return this.httpService
      .get<{ sellers: Seller[], metadata: ResponseMetadata }>(EndpointsConstants.seller.all, params)
      .pipe(map(response => {
        return {
          sellers: response['data'].sellers.map(machine => new Seller(machine)),
          metadata: response['data'].metadata
        };
      }));
  }

  getSeller(id: string): Observable<Seller> {
    const endpointUrl = EndpointsConstants.seller.single.replace('{id}', id);
    return this.httpService.get<Seller>(endpointUrl).pipe(map(response => new Seller(response['data'])));
  }

  saveSeller(seller: Seller): Observable<Seller> {
    return this.httpService.post(EndpointsConstants.seller.all, seller)
      .pipe(map(response => new Seller(response['data'])));
  }

  updateSeller(id: string, editedSeller: Seller): Observable<Seller> {
    const endpointUrl = EndpointsConstants.seller.single.replace('{id}', id);
    return this.httpService.put(endpointUrl, editedSeller).pipe(map(response => new Seller(response['data'])));
  }

  deleteSeller(id: string): Observable<{ message: string }> {
    const endpointUrl = EndpointsConstants.seller.single.replace('{id}', id);
    return this.httpService.delete<{ message: string }>(endpointUrl);
  }
}
